
/**
 * Функция для вывода ошибок в режиме разработки/отладки.
 * Для "обычных" ошибок выводит текст ошибки и место, где она возникла.
 * Для ошибок axios выводит объект response.
 * Стек вызовов в обоих случаев в консоли присутствует
 * в свернутом виде.
 *
 * @param {type} error
 * @returns {undefined}
 */
export function showServiceError(error) {
    if (config.appDebug !== 'true') {
        return;
    }
    if (error.response) {
        error = error.response;
    }
    console.error(error);
}

/**
 * Функция просто выводит сообщение, когда включен режим разработки/отладки.
 *
 * @param {type} message
 * @returns {undefined}
 */
export function showServiceMessage(message) {
    if (config.appDebug !== 'true') {
        return;
    }
    console.log(message);
}

/** Фунцкция удаляет куки с путем "/".
 * Внимание: куки с другим путем не удаляет!
 *
 * @param {type} name
 * @returns {undefined}
 */
export function deleteCookie(name) {
    document.cookie = `${name}=; max-age=-1; path=/; secure; samesite=none`;
}

/**
 * Функция устанавливает куки с путем "/".
 * Внимание: куки с другим путем не устанавливает!
 *
 * @param {type} name
 * @param {type} value
 * @param {type} maxAge - время жизни в секундах
 * @returns {undefined}
 */
export function setCookie(name, value, maxAge) {
    document.cookie = `${name}=${value}; max-age=${maxAge}; path=/; secure; samesite=none`;
}

/**
 * Функция извлечения куки по ключу
 * Внимание: протестировано только с путем "/".
 * @param {string} name
 * @returns {string|boolean}
 */
export function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length !== 2) {
        return false;
    }

    return parts.pop().split(';').shift();
}

/**
 * Отправка события в GoogleAnalytics
 *
 * @param message - сообщение события
 * @param category - категория сообщения
 * @param label - дополнительный параметр
 *
 * @return void
 */
export function sendGAEvent(category, message, label) {
    ga('send', 'event', category, message, label);
    return;
};
